import { useQuery, QueryFunction } from '@tanstack/react-query';
import { UseCustomHookProps } from './interfaces/useCustomHookProps';
interface UseWidgetDataProps extends UseCustomHookProps {
  queryFn?: QueryFunction<any, [string]>;
}

export const useWidgetData = ({ identifier, enabled = true, queryFn }: UseWidgetDataProps) => {
  return useQuery({
    queryKey: [identifier],
    queryFn: queryFn,
    enabled: enabled && !!identifier,
    refetchInterval: query => {
      const error = query.state.error as any;
      // Logic: If the error is a 404, stop refetching
      if (error?.response?.status === 404) {
        return false;
      }
      return 3000; // 3 seconds
    },
    refetchOnWindowFocus: true, // auto refetch when tab is focused
    staleTime: 3000,
  });
};
